import { useEffect, useState } from 'react'
import { Link } from 'react-router-dom'
import Button from '@mui/material/Button'
import NavigateNextIcon from '@mui/icons-material/NavigateNext'
import { useMediaQuery, useTheme } from '@mui/material'
import Collapsed from './Collapsed'
import StyledBreadcrumps, { IProps } from './StyledBreadCrumps'

const themeBreakpoint = (linkStackLength: number) => {
  if (linkStackLength <= 2) return 'xs'
  if (linkStackLength <= 3) return 'md'
  if (linkStackLength <= 4) return 'lg'
  if (linkStackLength <= 5) return 'xl'
  return 2500
}

function BreadCrump({ color, linkStack, ...rest }: IProps) {
  const theme = useTheme()
  const bigScreen = useMediaQuery(theme.breakpoints.up(themeBreakpoint(linkStack.length)))
  const [expanded, setIsExpanded] = useState(bigScreen)
  useEffect(() => {
    setIsExpanded(bigScreen)
  }, [bigScreen])
  if (!expanded) {
    return (<Collapsed expanded={expanded} setExpanded={setIsExpanded} color={color} linkStack={linkStack} {...rest} />)
  }
  return (
    (
      <StyledBreadcrumps
        separator={<NavigateNextIcon fontSize="small" />}
        aria-label="breadcrumb"
        color={color}
      >
        {
          linkStack.map((link: any) => {
            const attributes: any = {}
            if (link.to) {
              attributes.component = Link
              attributes.to = link.to
            }
            return (
              <Button
                color="inherit"
                key={`breadcrump-${link.text}`}
                variant="text"
                {...attributes}
              >
                {link.text}
              </Button>
            )
          })
        }
      </StyledBreadcrumps>
    )
  )
}

BreadCrump.defaultProps = {
  color: 'white',
}
export default BreadCrump
